"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabList = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _Legend = require("../microFields/Legend");

var _utils = require("../utils");

var _fieldUtils = require("../microFields/fieldUtils");

var _TabButton = require("./TabButton");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TabList =
/*#__PURE__*/
function (_Component) {
  _inherits(TabList, _Component);

  function TabList(props) {
    var _this;

    _classCallCheck(this, TabList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabList).call(this, props));
    var _this$props = _this.props,
        tabItems = _this$props.tabItems,
        defaultValue = _this$props.defaultValue;
    _this.state = {
      value: defaultValue || tabItems[0].value
    };
    _this.tabListRef = null;
    _this.setTabListRef = _this.setTabListRef.bind(_assertThisInitialized(_this));
    _this.getTabIndexFromValue = _this.getTabIndexFromValue.bind(_assertThisInitialized(_this));
    _this.focusTabList = _this.focusTabList.bind(_assertThisInitialized(_this));
    _this.getTabMeta = _this.getTabMeta.bind(_assertThisInitialized(_this));
    _this.selectTab = _this.selectTab.bind(_assertThisInitialized(_this));
    _this.gotoFirstTab = _this.gotoFirstTab.bind(_assertThisInitialized(_this));
    _this.gotoLastTab = _this.gotoLastTab.bind(_assertThisInitialized(_this));
    _this.gotoPreviousTab = _this.gotoPreviousTab.bind(_assertThisInitialized(_this));
    _this.gotoNextTab = _this.gotoNextTab.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleKeydown = _this.handleKeydown.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TabList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.focusTabList();
    }
  }, {
    key: "setTabListRef",
    value: function setTabListRef(element) {
      var innerRef = this.props.innerRef;
      this.tabListRef = element;
      if (innerRef) innerRef(element);
    }
  }, {
    key: "getTabIndexFromValue",
    value: function getTabIndexFromValue(value) {
      var tabItems = this.props.tabItems;
      return tabItems.findIndex(function (tabItem) {
        return tabItem.value === value;
      });
    }
  }, {
    key: "getTabMeta",
    value: function getTabMeta() {
      var innerWrapper = this.props.innerWrapper;
      var value = this.state.value;
      var tabMeta = {};

      if (this.tabListRef && value !== false) {
        var tabs = innerWrapper ? this.tabListRef.children[0].children : this.tabListRef.children;

        if (tabs.length > 0) {
          var tab = tabs[this.getTabIndexFromValue(value)]; // eslint-disable-next-line no-console

          if (!tab) console.warn("[cstar-react-primitives]: the provided TabButton value '".concat(value, "' is invalid"));
          tabMeta = tab ? tab.getBoundingClientRect() : null;
        }
      }

      return tabMeta;
    }
  }, {
    key: "focusTabList",
    value: function focusTabList() {
      var doFocus = this.props.doFocus;

      if (doFocus && this.tabListRef) {
        this.tabListRef.focus();
      }
    }
  }, {
    key: "selectTab",
    value: function selectTab(tab) {
      var _this2 = this;

      if (!tab) return;
      var handleSelect = this.props.handleSelect;
      this.setState({
        value: tab
      }, // setState updates state asynchronously. handleSelect needs to use the updated `value`,
      // so we need to call handleSelect in the callback to ensure it's operating on the new tab value
      function () {
        return handleSelect(tab, _this2.getTabMeta());
      });
    }
  }, {
    key: "gotoFirstTab",
    value: function gotoFirstTab() {
      var tabItems = this.props.tabItems;
      this.selectTab(tabItems[0].value);
    }
  }, {
    key: "gotoLastTab",
    value: function gotoLastTab() {
      var tabItems = this.props.tabItems;
      this.selectTab(tabItems[tabItems.length - 1].value);
    }
  }, {
    key: "gotoPreviousTab",
    value: function gotoPreviousTab() {
      var tabItems = this.props.tabItems;
      var value = this.state.value;
      var index = this.getTabIndexFromValue(value); // If the current tab is already the first tab, circle round to the last tab

      if (index === 0) {
        this.gotoLastTab();
      } else {
        // Else go to the previous tab
        this.selectTab(tabItems[index - 1].value);
      }
    }
  }, {
    key: "gotoNextTab",
    value: function gotoNextTab() {
      var tabItems = this.props.tabItems;
      var value = this.state.value;
      var index = this.getTabIndexFromValue(value); // If the current tab is already the last tab, circle round to the first tab

      if (index === tabItems.length - 1) {
        this.gotoFirstTab();
      } else {
        // Else go to the next tab
        this.selectTab(tabItems[index + 1].value);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e, tab) {
      e.preventDefault();
      this.selectTab(tab);
    }
    /**
     * Per the WAI ARIA Tab List Design Pattern the following interaction is supported:
     *
     * When focus is on a tab element in a horizontal tab list:
     *      Left Arrow: moves focus to the previous tab. If focus is on the first tab, moves focus to the last tab.
     *      Right Arrow: Moves focus to the next tab. If focus is on the last tab element, moves focus to the first tab.
     *
     * When focus is on a tab in a tablist with either horizontal or vertical orientation:
     *      Space or Enter: Activates the tab if it was not activated automatically on focus.
     *      Home (Optional): Moves focus to the first tab.
     *      End (Optional): Moves focus to the last tab.
     *
     * WAI ARIA recommendation is that when a tab receives focus it "automatically activates" the newly focused tab.
     */

  }, {
    key: "handleKeydown",
    value: function handleKeydown(e) {
      switch (e.key) {
        case 'ArrowLeft':
          e.preventDefault();
          this.gotoPreviousTab();
          break;

        case 'ArrowRight':
          e.preventDefault();
          this.gotoNextTab();
          break;

        case 'Home':
          e.preventDefault();
          this.gotoFirstTab();
          break;

        case 'End':
          e.preventDefault();
          this.gotoLastTab();
          break;

        case 'Enter':
        case ' ':
        case 'Spacebar':
          // for older browsers
          e.preventDefault();
          this.selectTab();
          break;

        default:
          break;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          name = _this$props2.name,
          cashbotName = _this$props2.cashbotName,
          legend = _this$props2.legend,
          cssClass = _this$props2.cssClass,
          style = _this$props2.style,
          hasTabPanel = _this$props2.hasTabPanel,
          fullWidth = _this$props2.fullWidth,
          innerWrapper = _this$props2.innerWrapper,
          tabItems = _this$props2.tabItems;
      var value = this.state.value;
      var className = (0, _dedupe.default)('tab-container', 'tab-container--top-flush', cssClass); // prepare child tabs

      var tabs = tabItems.map(function (tab) {
        return _react.default.createElement(_TabButton.TabButton, {
          key: "".concat(tab.value, "-tab"),
          value: tab.value,
          label: tab.label,
          isSelected: tab.value === value,
          handleClick: _this3.handleClick,
          hasTabPanel: hasTabPanel,
          fullWidth: fullWidth
        });
      });
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_Legend.Legend, {
        id: "".concat(name, "-legend"),
        message: legend
      }), _react.default.createElement("div", _extends({}, (0, _utils.getCashbotAttrs)(name, cashbotName), {
        className: className,
        style: style,
        role: "tablist",
        "aria-describedby": "".concat(name, "-legend"),
        "aria-activedescendant": "".concat(value, "-tab"),
        tabIndex: "0",
        onKeyDown: this.handleKeydown,
        ref: this.setTabListRef
      }), innerWrapper ? innerWrapper(tabs) : tabs));
    }
  }]);

  return TabList;
}(_react.Component);

exports.TabList = TabList;
TabList.defaultProps = {
  doFocus: false,
  cssClass: '',
  style: {},
  innerRef: function innerRef() {},
  defaultValue: null,
  handleSelect: function handleSelect() {},
  hasTabPanel: false,
  fullWidth: false,
  innerWrapper: null
};
TabList.propTypes = {
  name: _propTypes.default.string.isRequired,
  cashbotName: _propTypes.default.string.isRequired,
  legend: _propTypes.default.string.isRequired,
  cssClass: _propTypes.default.string,
  style: _propTypes.default.object,
  doFocus: _propTypes.default.bool,
  innerRef: _propTypes.default.func,

  /**
   * Array of objects in the shape { label: {string}, value: {string|number} }
   */
  tabItems: _fieldUtils.optionsPropTypes.isRequired,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  handleSelect: _propTypes.default.func,
  hasTabPanel: _propTypes.default.bool,
  // NOTE: not fully implemented yet

  /**
   * If `true`, the tabs will grow to use all the available space.
   * This property is intended for small views, like on mobile.
   */
  fullWidth: _propTypes.default.bool,

  /**
   * A functional component that the tabs are passed to as children
   * if additional wrapping is needed
   */
  innerWrapper: _propTypes.default.func
};